import { render, staticRenderFns } from "./room-policy-list.vue?vue&type=template&id=bb0bce76"
import script from "./room-policy-list.vue?vue&type=script&lang=ts"
export * from "./room-policy-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports